import { useNavigate } from 'react-router-dom';

/** Centralizes the `/cars/:make/:model` URL shape so every screen builds links the same way. */
export function useCarNavigation() {
  const navigate = useNavigate();

  return {
    goToBrandList: () => navigate('/cars'),
    goToModelList: (make: string) => navigate(`/cars/${encodeURIComponent(make)}`),
    goToCarDetails: (make: string, model: string) =>
      navigate(`/cars/${encodeURIComponent(make)}/${encodeURIComponent(model)}`),
  };
}
